<div [class]="isRootMenu()?'flex-row':''">
  @for (menuItem of menuItems; track menuItem) {
    <div class="menu-item">
      @if(!menuItem.hidden){
        @if (menuItem.raisedButton) {
          <div>
            @if (menuItem.routerLink && !menuItem.hasSubMenu) {
              <a mat-raised-button class="primary-menu-button" [routerLink]="menuItem.routerLink" [queryParams]="menuItem.queryParams" routerLinkActive="horizontal-active-link"  [id]="'menu-item-'+menuItem.id">
                <span>{{menuItem.title}}</span>
              </a>
            }
            @if (menuItem.href && !menuItem.hasSubMenu) {
              <a mat-raised-button class="primary-menu-button" [attr.href]="menuItem.href || ''" [attr.target]="menuItem.target || ''" [id]="'menu-item-'+menuItem.id">
                <span>{{menuItem.title}}</span>
              </a>
            }
            @if (menuItem.hasSubMenu && menuItem.parentId == 0) {
              <a mat-raised-button class="primary-menu-button" [matMenuTriggerFor]="menu" [id]="'menu-item-'+menuItem.id">
                <span>{{menuItem.title}}</span>
                <mat-icon iconPositionEnd class="menu-expand-icon transition-2">arrow_drop_down</mat-icon>
              </a>
            }
          </div>
        }
        @else {
          <div>
            @if (menuItem.routerLink && !menuItem.hasSubMenu) {
              <a mat-button class="primary-menu-button" [routerLink]="menuItem.routerLink" [queryParams]="menuItem.queryParams" routerLinkActive="horizontal-active-link"  [id]="'menu-item-'+menuItem.id">
                <span>{{menuItem.title}}</span>
              </a>
            }
            @if (menuItem.href && !menuItem.hasSubMenu) {
              <a mat-button class="primary-menu-button" [attr.href]="menuItem.href || ''" [attr.target]="menuItem.target || ''" [id]="'menu-item-'+menuItem.id">
                <span>{{menuItem.title}}</span>
              </a>
            }
            @if (menuItem.hasSubMenu && menuItem.parentId == 0) {
              <a mat-button class="primary-menu-button" [matMenuTriggerFor]="menu" [id]="'menu-item-'+menuItem.id">
                <span>{{menuItem.title}}</span>
                <mat-icon iconPositionEnd class="menu-expand-icon transition-2">arrow_drop_down</mat-icon>
              </a>
            }
          </div>
        }
      }
      <mat-menu #menu="matMenu" class="horizontal-sub-menu">
        <app-horizontal-menu [menuParentId]="menuItem.id" [isRootMenu]="false"></app-horizontal-menu>
      </mat-menu>
    </div>
  }
</div>
